export type State = {
  apiToken: Maybe<APIToken>
}

const initialState: State = {
  apiToken: undefined,
}
export const state = (): State => initialState
